<template>
    <div>
        <header class="row">
            <div class="col-sm-7">
                <h2>{{ this.title}}</h2>
            </div>

            <div class="col-sm-5">
                <slot></slot>
            </div>
        </header>

        <hr />
    </div>
</template>

<script>
    export default {
        props: ["title"],
        name: "Header"
    }
</script>